<template>
  <div id="screen1" ref="screen1">
    <!-- <div class="shuaxin" @click="shuaxin">刷新</div> -->

    <div class="title">
      <div class="user">
        <span><i class="el-icon-user"></i> {{ userName }}</span>
      </div>
      <div class="ws">
        <!-- <div class="weather">
          <iframe
            width="300"
            height="30"
            src="https://i.tianqi.com/?c=code&a=getcode&id=34&py=chongqing&icon=1"
            frameborder="0"
          ></iframe>
        </div> -->
        <div>{{ time }}</div>
        <!-- <div id="slogan" ref="slogan">
          国家高新技术企业,让医用织物管理更智能;
        </div> -->
        <marquee
          class="marquee"
          behavior="scroll"
          direction="left"
          style="overflow: hidden"
          scrollamount="5"
          onMouseOver="stop()"
          onMouseOut="start()"
        >
          <div class="item">让 医 用 织 物 管 理 更 智 能</div>
        </marquee>
      </div>
      <div>{{$systemTitle}}</div>
    </div>
    <div class="centent">
      <div class="left">
        <div class="left1">
          <div>医院客户</div>
          <div>
            总计 <span>{{ hospitalList.length }}</span> 家
          </div>
          <div>
            <el-select v-model="hospital" placeholder="请选择医院>>">
              <el-option
                v-for="item in hospitalList"
                :key="item.ID"
                :label="item.RegionName"
                :value="item"
                :disabled="item.ID < 0"
              >
              </el-option>
            </el-select>
          </div>
          <div></div>
        </div>
        <div class="left2">
          <div>织物数量</div>
          <div class="scroll-bd" @click="toggleClick(0)">
            <div class="scroll-list">
              <div class="scroll-half">
                <div
                  class="scroll-item"
                  ref="scrollItem1"
                  v-for="(item, index) in scrollList1"
                  :key="index"
                  :style="styleFormatter(index)"
                >
                  <div
                    :class="[
                      index % 2 !== 0
                        ? 'scroll-bd-item color'
                        : 'scroll-bd-item',
                    ]"
                  >
                    <div class="tit1">
                      {{ item.RegionName }}
                    </div>
                    <div class="tit1">{{ item.num }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left3">
          <div>织物丢失统计</div>
          <div>
            <Eharts :options="options1" ref="charts1"></Eharts>
          </div>
        </div>
      </div>
      <div class="right">
        <div style="flex:0.01; margin:0;">
        </div>
        <div class="right1">
          <div>织物收发数据统计</div>

          <vue-seamless-scroll
            :data="hospitalDailySendAndReceInfo"
            class="seamless-warp"
          >
            <div id="rank-parent">
              <div id="rank-data">
                <div
                  v-for="(item, index) in hospitalDailySendAndReceInfo"
                  :key="index"
                >
                  <div>{{ item.RegionName }}</div>
                  <div>回收织物：{{ item.rece_num }}件</div>
                  <div>发放织物：{{ item.send_num }}件</div>
                  <div>收发日期：{{ item.DAY }}</div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="right2">
          <div>织物库存量统计</div>
          <div>
            <Eharts :options="options2" ref="charts2"></Eharts>
          </div>
        </div>
        <div class="right3">
          <div>织物洗涤量统计</div>
          <div>
            <Eharts :options="options3" ref="charts3"></Eharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Eharts from "@/components/echarts";
import echarts from "echarts";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    Eharts,
    vueSeamlessScroll,
  },
  data() {
    return {
      clientHeight: "0",
      userName: localStorage.getItem("userName"),
      time: null,
      date: null,
      options1: {
        legend: {
          orient: "vertical",
          top: "center",
          left: "5%",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        color: [
          "rgba(50,123,250,0.5)",
          "rgba(244,201,7,0.5)",
          "rgba(23,216,161,0.5)",
          "rgba(122,60,235,0.5)",
          "rgba(122,60,235,5)",
          "rgba(15,197,243,0.5)",
        ],
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "80%"],
            center: ["70%", "50%"],
            roseType: "radius",
            label: {
              normal: {
                show: false,
                position: "outside",
                fontSize: 16,
              },
            },
            itemStyle: {},
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
      options2: {
        legend: {
          right: 0,
          top: 10,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 16,
          },
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 18,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
        },
        grid: {
          top: "25%",
          bottom: "1%",
          left: "1%",
          right: "1%",
          containLabel: true,
        },
        series: [
          {
            type: "bar",
            name: "工作服类",
            showSymbol: false,
            barWidth: 25,
            // barGap:"100%",
            data: [105, 229, 391, 434, 457, 376, 391],
            smooth: true,
            itemStyle: {
              color: "#00d2f6",
            },
          },
          {
            type: "bar",
            name: "手术服类",
            showSymbol: false,
            barWidth: 25,
            data: [156, 490, 434, 490, 400, 530, 510],
            smooth: true,
            itemStyle: {
              color: "#006ce6",
            },
          },
          {
            type: "bar",
            name: "病房五件套类",
            showSymbol: false,
            barWidth: 25,

            data: [126, 323, 451, 391, 434, 490, 530],
            smooth: true,
            itemStyle: {
              color: "#4d9f87",
            },
          },
          {
            type: "bar",
            name: "其它类",
            showSymbol: false,
            barWidth: 25,

            data: [96, 323, 546, 490, 450, 391, 434],
            smooth: true,
            itemStyle: {
              color: "#6870d0",
            },
          },
        ],
      },
      options3: {
        legend: {
          right: 0,
          top: 10,
          icon: "circle",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#BBCFFF",
            fontSize: 16,
          },
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          textStyle: {
            color: "#FFF",
            fontSize: 18,
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(12, 72, 111, 0.5)",
              width: "3",
            },
          },
          axisTick: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          name: "单位",
          nameGap: 20,
          nameTextStyle: {
            color: "#fff",
            fontSize: 18,
            padding: [0, 50, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            //show:false,
            textStyle: {
              color: "#FFF",
              fontSize: 16,
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
              width: "2",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0c3e71",
            },
          },
        },
        grid: {
          top: "25%",
          bottom: "1%",
          left: "1%",
          right: "1%",
          containLabel: true,
        },
        series: [
          {
            type: "bar",
            name: "深圳市坪山区妇幼保健院",
            showSymbol: false,
            // barWidth: 25,
            // barGap:"100%",
            data: [105, 229, 391, 434, 457, 376, 391],
            smooth: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0.7,
                  color: "rgba(0, 164, 245, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(200, 233, 250, 1)",
                },
              ]),
              barBorderRadius: [10, 10, 0, 0],
            },
          },
          // {
          //   type: "bar",
          //   name: "医院2",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   data: [156, 490, 434, 490, 400, 530, 510],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(0, 101, 236, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(211, 228, 250, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // },
          // {
          //   type: "bar",
          //   name: "医院3",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   data: [126, 323, 451, 391, 434, 490, 530],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(80, 196, 138, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(192, 245, 218, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // },
          // {
          //   type: "bar",
          //   name: "医院4",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   data: [96, 323, 546, 490, 450, 391, 434],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(230, 231, 110, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(244, 244, 211, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // },
          // {
          //   type: "bar",
          //   name: "医院5",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   // barGap:"100%",
          //   data: [105, 229, 391, 434, 457, 376, 391],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(244, 167, 44, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(252, 242, 225, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // },
          // {
          //   type: "bar",
          //   name: "医院6",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   data: [156, 490, 434, 490, 400, 530, 510],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(228, 70, 96, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(253, 214, 221, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // },
          // {
          //   type: "bar",
          //   name: "医院7",
          //   showSymbol: false,
          //   // barWidth: 25,
          //   data: [126, 323, 451, 391, 434, 490, 530],
          //   smooth: true,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //         offset: 0.7,
          //         color: "rgba(180, 72, 236, 1)"
          //       },
          //       {
          //         offset: 1,
          //         color: "rgba(238, 217, 249, 1)"
          //       }
          //     ]),
          //     barBorderRadius: [10, 10, 0, 0]
          //   }
          // }
        ],
      },
      hospital: null,
      showRankInterVal: [],
      hospitalList: [],
      hospitalDailySendAndReceInfo: [],
      scrollList1: [],
      // 滚动速度
      speed: 30,
      // 每个元素的高度
      height: 35,
      isScrolling: [false, false],
    };
  },
  created() {
    // // 获取浏览器可视区域高度
    // this.clientHeight = document.documentElement.clientHeight;
    // let that = this;
    // window.onresize = function temp() {
    //   // 在窗口或框架被调整大小时触发
    //   this.clientHeight = document.documentElement.clientHeight;
    //   that.$router.go(0);
    // };
  },
  mounted() {
    setInterval(() => {
      this.setTime();
    }, 1000);

    this.hospitalList = JSON.parse(localStorage.getItem("hospitalList"));

    this.eachHospitalLossedInfo();
    this.eachHospitalTextileCount();
    this.eachHospitalDailySendAndReceInfo();
    this.eachHospitalStoreInfo();
    this.eachHospitalSendMonthInfo();
    //this.sloganScroll();
  },
  methods: {
    setTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      let week = date.getDay();
      switch (week) {
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
        case 0:
          week = "星期日";
          break;
        default:
          break;
      }
      var mytime = date.toLocaleTimeString(); //获取当前时间
      this.date = year + "-" + month + "-" + day;
      this.time = year + "-" + month + "-" + day + " " + week + " " + mytime;
    },

    sloganScroll() {
      var that = this;
      setInterval(function () {
        var oTxt = document.getElementById("slogan"); //获取标签
        var txt = oTxt.innerText; //获取标签文本内容
        // console.log(typeof txt)  页面控制台查看是string
        var first_i = txt[0]; //字符串索引取值
        var last_i = txt.slice(1, txt.length); //字符串切片
        var new_txt = last_i + first_i; //字符串拼接
        oTxt.innerText = new_txt; //拼接后的字符串放到标签文本内容
      }, 800);
    },

    // 获取天气温度
    getNowWeather() {
      $.get("http://wthrcdn.etouch.cn/weather_mini?city=深圳", function (res) {
        var result = JSON.parse(res).data;
        var weather = result.forecast[0].type;
        var low = result.forecast[0].low.slice(2);
        var high = result.forecast[0].high.slice(2);
        $(".hd-weather").html("天气：" + weather);
        $(".hd-temperature").html(low + "-" + high);
      });
    },

    changeFixed(clientHeight) {
      // 动态修改样式
      this.$refs.screen1.style.height = clientHeight + "px";
    },

    // 布草丢失情况
    eachHospitalLossedInfo() {
      const requestData = {
        url: process.env.BASE_API + "/admin/eachHospitalLossedInfo",
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let arr = [];
        res.data.forEach((item) => {
          arr.push({
            value: item.lossedNum,
            name: item.RegionName,
          });
        });
        this.options1.series[0].data = arr;
        this.$refs.charts1.drawCharts();
      });
    },
    // 各医院布草数量
    eachHospitalTextileCount() {
      const requestData = {
        url: process.env.BASE_API + "/admin/eachHospitalTextileCount",
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        this.scrollList1 = res.data;
        // if (this.scrollList1.length < 5) {
        //   let num = 5 - this.scrollList1.length;
        //   for (let i = 0; i < num; i++) {
        //     this.scrollList1.push({
        //       ID: 6,
        //       RegionName: "",
        //       num: ""
        //     });
        //   }
        // }
        // this.$nextTick(() => {
        //   this.initListener(0);
        //   this.scroll(0);
        // });
      });
    },
    toggleClick(index) {
      if (this.isScrolling[index]) {
        this.isScrolling[index] = false;
        this.scroll(index);
      } else {
        this.isScrolling[index] = true;
        this.pause(index);
      }
    },
    // 根据索引计算当前元素所在位置
    styleFormatter(index) {
      return {
        top: `${index * this.height}px`,
      };
    },
    // 控制滚动开始
    scroll(index) {
      let elementList = null;
      if (index == 0) {
        elementList = this.$refs.scrollItem1;
      } else if (index == 1) {
        elementList = this.$refs.scrollItem2;
      } else {
        elementList = this.$refs.scrollItem3;
      }
      elementList.forEach((ele) => {
        ele.style.transitionDuration = `${
          (ele.offsetTop + this.height) / this.speed
        }s`;
        ele.style.top = `-${this.height}px`;
      });
    },
    // 暂停滚动
    pause(index) {
      let elementList = null;
      if (index == 0) {
        elementList = this.$refs.scrollItem1;
      } else if (index == 1) {
        elementList = this.$refs.scrollItem2;
      } else {
        elementList = this.$refs.scrollItem3;
      }
      elementList.forEach((ele) => {
        const styles = getComputedStyle(ele, null);
        ele.style.transitionDuration = "0s";
        ele.style.top = `${styles.top}`;
      });
    },
    // 初始化listener，监听滚动动画
    // 当元素完全滚动至显示范围外时，则将该元素插入队尾
    initListener(index) {
      let elementList = null;
      if (index == 0) {
        elementList = this.$refs.scrollItem1;
      } else if (index == 1) {
        elementList = this.$refs.scrollItem2;
      } else {
        elementList = this.$refs.scrollItem3;
      }
      elementList.forEach((ele) => {
        // 当动画结束后会触发transitionend事件
        ele.addEventListener("transitionend", () => {
          // 计算队尾位置
          const lastestElementPosition = this.lastestElementPosition(index);
          ele.style.transitionDuration = `0s`;
          ele.style.top = `${lastestElementPosition + this.height}px`;
          // 渲染完毕之后开始滚动
          this.$nextTick(() => {
            ele.style.transitionDuration = `${
              (ele.offsetTop + 35) / this.speed
            }s`;
            ele.style.top = `-${this.height}px`;
          });
        });
      });
    },
    // 计算最后一个元素的位置
    lastestElementPosition(index) {
      let elementList = null;
      if (index == 0) {
        elementList = this.$refs.scrollItem1;
      } else if (index == 1) {
        elementList = this.$refs.scrollItem2;
      } else {
        elementList = this.$refs.scrollItem3;
      }
      return Math.max(
        ...elementList.map((ele) => {
          // 注意，这里不能直接读取ele.style.top，这样只能读到终点位置的偏移量，而我们需要的是当前元素的实际位置，需要通过getComputedStyle来获取
          const styles = getComputedStyle(ele, null);
          return parseFloat(styles.top);
        })
      );
    },
    // 各医院每日收发布草情况
    eachHospitalDailySendAndReceInfo() {
      const requestData = {
        url: process.env.BASE_API + "/admin/eachHospitalDailySendAndReceInfo",
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        this.hospitalDailySendAndReceInfo = resData;
        this.$nextTick(() => {
          //this.roll(60, this.showRankInterVal, "rank-data", "rank-parent");
        });
      });
    },
    // 各医院布草库存统计 - 按布草类别
    eachHospitalStoreInfo() {
      const requestData = {
        url: process.env.BASE_API + "/admin/eachHospitalStoreInfo",
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [],
          arr4 = [],
          arr5 = [];

        resData.forEach((item) => {
          arr1.push(item.RegionName);
          arr2.push(item.y_工服类);
          arr3.push(item.y_手术室);
          arr4.push(item.y_病房类);
          arr5.push(item.y_其他类);
        });
        this.options2.xAxis.data = Array.from(new Set(arr1));
        this.options2.series[0].data = arr2;
        this.options2.series[1].data = arr3;
        this.options2.series[2].data = arr4;
        this.options2.series[3].data = arr5;
        this.$refs.charts2.drawCharts();
      });
    },
    // 各医院布草送洗月度情况
    eachHospitalSendMonthInfo() {
      const requestData = {
        url: process.env.BASE_API + "/admin/eachHospitalSendMonthInfo",
        method: "post",
      };
      this.$axios(requestData).then((res) => {
        let resData = res.data;
        let arr1 = [],
          arr2 = [],
          arr3 = [];
        resData.forEach((item) => {
          arr1.push(item.month);
          arr2.push(item.y_深圳市坪山区妇幼保健院);
        });
        arr1 = Array.from(new Set(arr1));
        this.options3.xAxis.data = arr1;
        // for (let i = 0; i < arr1.length; i++) {
        //   arr4.push({
        //     type: "bar",
        //     name: arr1[i],
        //     barWidth: 25,
        //     showSymbol: false,
        //     data: arr3.reverse(),
        //     smooth: true,
        //     itemStyle: {
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0.7,
        //           color:
        //             "#" +
        //             Math.random()
        //               .toString(16)
        //               .substr(2, 6)
        //               .toUpperCase()
        //         },
        //         {
        //           offset: 1,
        //           color: "rgba(211, 228, 250, 1)"
        //         }
        //       ]),
        //       barBorderRadius: [100, 100, 0, 0]
        //     }
        //   });
        // }
        this.options3.series[0].data = arr2;
        this.$refs.charts3.drawCharts();
      });
    },
    // 滚动效果
    /**
     *
     * @param {*速度} t
     * @param {*window对象用于清除定时器} container
     * @param {* 子容器id} sunId
     * @param {* 父容器id} parId
     */
    roll(t, container, sunId, parId) {
      let that = this;
      if (document.getElementById(parId)) {
        var ulbox = document.getElementById(parId);
        ulbox.scrollTop = 0; // 开始无滚动时设为0
        var timer = setInterval(() => {
          that.oilRollStart(sunId, parId);
        }, t);
        // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
        // 鼠标移入div时暂停滚动
        container.push(timer);
        ulbox.onmouseover = function () {
          clearInterval(timer);
          container.forEach(function (item) {
            clearInterval(item);
          });
        };
        // 鼠标移出div后继续滚动
        ulbox.onmouseout = function () {
          timer = setInterval(() => {
            that.oilRollStart(sunId, parId);
          }, t);
          container.push(timer);
        };
      }
    },
    // 开始滚动函数
    oilRollStart(sunId, parId) {
      // 上面声明的DOM对象为局部对象需要再次声明
      var ul1 = document.getElementById(sunId);
      var ulbox = document.getElementById(parId);
      // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
      if (ulbox.scrollTop + ulbox.clientHeight >= ul1.scrollHeight) {
        ulbox.scrollTop = 0;
      } else {
        ulbox.scrollTop += 1;
      }
    },
    shuaxin() {
      this.$router.go(0);
    },
  },
  watch: {
    // // // 监听屏幕高度
    // clientHeight() {
    //   this.changeFixed(this.clientHeight);
    // },
    hospital() {
      if (this.hospital.ID > 0) {
        this.$router.push({
          path: "/screen2",
          query: {
            hospitalID: this.hospital.ID,
            RegionName: this.hospital.RegionName,
          },
        });
      }
    },
  },
  beforeDestroy() {
    this.showRankInterVal.forEach((item) => {
      clearInterval(item);
    });
  },
};
</script>

<style lang="less" scoped>
#screen1 {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../../assets/image/screen1/bg_1_v2.jpeg") no-repeat;
  background-size: 100% 100%;
  .shuaxin {
    position: absolute;
    left: 5%;
    top: 4%;
    display: inline-block;
    color: #fff;
    border: 1px solid #00cdff;
    padding: 0.5rem;
  }
  .title {
    height: 6.5%;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    color: #00cdff;
    font-size: 1.2rem;


    div:nth-child(3) {
      flex: 10;
      text-align: right;
      padding-right: 19rem;
      font-size: 2rem;
      font-weight: bold;
    }

    .ws {
      color: #fff;
      flex: 3;
      margin-left: 20px;
      .marquee {
        margin-left: 2rem;
        .item {
          margin-top: 5px;
        }
      }

      > div:nth-child(1) {
        padding-left: 2rem;
      }
    }

    #slogan {
      letter-spacing: 1rem;
      height: 50%;
    }

    > .user {
      span:nth-child(1) {
        padding-right: 1.5rem;

        i {
          font-size: 1.5rem;
        }
      }
    }
  }

  .centent {
    display: flex;
    width: 100%;
    height: 93.5%;
    padding: 1rem;

    .left {
      flex: 1;
      display: flex;
      flex-direction: column;

      > div {
        flex: 1;
        margin: 1rem;
        padding: 1rem;
      }

      .left1 {
        background: url("../../assets/image/screen1/s1_left1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;

        > div:nth-child(1) {
          font-size: 1.2rem;
          color: #00cdff;
          margin: 0.8rem 0 0 1rem;
        }

        > div:nth-child(2) {
          margin-top: 3rem;
          color: #ccc;
          text-align: center;
          font-size: 1.2rem;

          span {
            font-size: 3rem;
            color: #00cdff;
          }
        }

        > div:nth-child(3) {
          margin-top: 2rem;
          text-align: center;
          color: #00cdff;

          /deep/ .el-select {
            width: 60%;
          }

          /deep/ .el-input__inner {
            text-align: center;
            background: linear-gradient(to right, #0066e5, #00b6ff);
            border: 0;
            color: #fff;
          }
        }
        // > div:nth-child(4) {
        //   position: absolute;
        //   right: 0;
        //   top: 0;
        //   width: 45%;
        //   height: 45%;
        //   background: url("../../assets/image/login/logo.png") no-repeat;
        //   background-size: 100% 100%;
        // }
      }

      .left2 {
        background: url("../../assets/image/screen1/s1_left3.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          color: #00cdff;
          margin: 0.3rem 0 0 1rem;
        }

        .scroll-bd {
          flex: 1;
          padding-top: 1rem;
          width: 100%;
          height: 90%;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          text-align: center;

          .scroll-list {
            width: 100%;
            height: 100%;
            position: absolute;
            overflow-y: auto;

            .scroll-half {
              width: 100%;
              height: 80%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .scroll-item {
                width: 100%;
                height: 35px;
                line-height: 35px;
                font-size: 13px;
                color: #b8cfff;
                // display: flex;
                // justify-content: space-around;
                // position: absolute;
                // transition-property: top;
                // transition-timing-function: linear;

                .scroll-bd-item {
                  width: 100%;
                  display: flex;
                  justify-content: space-around;

                  .tit1 {
                    font-size: 1rem;
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                }
              }

              .color {
                background: linear-gradient(
                  to right,
                  rgba(255, 255, 255, 0),
                  rgba(23, 78, 128, 0.5),
                  rgba(255, 255, 255, 0)
                );
              }
            }
          }
        }
      }

      .left3 {
        background: url("../../assets/image/screen1/s1_left3.png") no-repeat;
        background-size: 100% 100%;

        display: flex;
        flex-direction: column;
        overflow: hidden;

        > div:nth-child(1) {
          font-size: 1.2rem;
          color: #00cdff;
          margin: 0.3rem 0 0 1rem;
        }

        > div:nth-child(2) {
          flex: 1;
        }
      }
    }

    .right {
      flex: 2.5;
      display: flex;
      flex-direction: column;

      > div {
        flex: 1;
        margin: 1rem;
        padding: 1rem;
      }

      .right1 {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin: 0;
        padding-top: 0;

        > div:nth-child(1) {
          font-size: 1.2rem;
          color: #00cdff;
          padding: 0.5rem 1rem 0.5rem 1rem;
          background: url("../../assets/image/screen1/s1_left_t.png") no-repeat;
          background-size: auto 100%;
          background-position: right;
          text-align: right;
          padding-top: 0.5rem;
          margin-bottom: 0.5rem;
          margin-top: 0;
        }

        .seamless-warp {
          overflow: hidden;
        }

        #rank-parent {
          flex: 1;
          overflow-y: auto;

          #rank-data {
            display: flex;
            flex-wrap: wrap;
            > div {
              // flex: 20%;
              width: 22.5%;
              margin: 1rem;
              padding: 2rem;
              text-align: center;
              background: url("../../assets/image/screen1/s1_right1.png")
                no-repeat;
              background-size: 100% 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-around;

              > div:nth-child(1) {
                color: #fff;
                font-size: 1rem;
                padding: 0.5rem;
                border-radius: 0.5rem;
                background: linear-gradient(to right, #0066e5, #00b6ff);
              }

              > div:nth-child(2) {
                color: #ccc;
                font-size: 1.1rem;
                margin: 0.5rem 0;
              }

              > div:nth-child(3) {
                color: #00dbff;
                font-size: 1.1rem;
              }

              > div:nth-child(4) {
                margin-top: 0.5rem;
                color: #fff;
                font-size: 1rem;
              }
            }
          }
        }
      }

      .right2,
      .right3 {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: url("../../assets/image/screen1/s1_right2.png") no-repeat;
        background-size: 100% 100%;

        > div:nth-child(1) {
          font-size: 1.2rem;
          color: #00cdff;
          margin: 0.25rem 0 0 1rem;
        }

        > div:nth-child(2) {
          flex: 1;
          padding: 0 1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/page/screen1.vue